import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

/**
 * Renders a list of clickable items. Each item must be
 * a ListItem component.
 */
export const List = ({ children }: Props) => {
  return <div className="list">{children}</div>;
};
